import React, {useEffect, useState} from 'react';
import SponsorPolicyComponent from '../../../Components/UserComponents/SponsorPolicy';

const SponsorPolicyContainer = () => {
  return <SponsorPolicyComponent />;
};

export default SponsorPolicyContainer;
